import { ADMIN_FAQ_GROUP_EDIT } from './index';
import { Action } from '../action';
import { FaqGroupInfo } from '@shared/core';

export class AdminFaqGroupEditInitAction implements Action {
	readonly type = ADMIN_FAQ_GROUP_EDIT.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminFaqGroupEditDestroyAction implements Action {
	readonly type = ADMIN_FAQ_GROUP_EDIT.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminFaqGroupEditCancelAction implements Action {
	readonly type = ADMIN_FAQ_GROUP_EDIT.CANCEL;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminFaqGroupEditClickBackAction implements Action {
	readonly type = ADMIN_FAQ_GROUP_EDIT.CLICK_BACK;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminFaqGroupEditSubmitAction implements Action {
	readonly type = ADMIN_FAQ_GROUP_EDIT.SUBMIT;
	constructor(
		public payload: FaqGroupInfo,
		public correlationId?: number
	) {}
}

export class AdminFaqGroupEditSubmitSuccessAction implements Action {
	readonly type = ADMIN_FAQ_GROUP_EDIT.SUBMIT_SUCCESS;
	constructor(
		public payload: FaqGroupInfo,
		public correlationId?: number
	) {}
}

export class AdminFaqGroupEditSubmitFailureAction implements Action {
	readonly type = ADMIN_FAQ_GROUP_EDIT.SUBMIT_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}
